/**
 * JS-side design tokens for props / inline styles that cannot take a CSS class
 * (e.g. icon `color`, LoadingIndicator `color`). Values are the CSS custom
 * properties emitted by `generateCSSVariablesNew` (utils/cssVariablesNew.ts).
 * Prefer SCSS (`mix.color(...)`) wherever a class can be used.
 */
const cssVar = <T extends `--${string}`>(name: T) => `var(${name})` as const

export const cssColors = {
  brand: {
    primary: cssVar('--color-brand-primary'),
    secondary: cssVar('--color-brand-secondary'),
    secondaryLight: cssVar('--color-brand-secondary-light'),
    tertiary: cssVar('--color-brand-tertiary'),
    tertiaryLight: cssVar('--color-brand-tertiary-light'),
    quaternary: cssVar('--color-brand-quaternary'),
    quinary: cssVar('--color-brand-quinary')
  },
  background: {
    base: cssVar('--color-background-base')
  },
  text: {
    baseOnDark: cssVar('--color-text-base-on-dark')
  },
  system: {
    success: { text: cssVar('--color-system-success-text') },
    error: { text: cssVar('--color-system-error-text') }
  }
} as const
